<template>
  <div class='ui-actions'>
    <a data-tip="Reorder" v-if='hasButton("reorder")' @mousedown='notifyReorder' class='handle'><ion-icon name="move"></ion-icon></a>
    <a data-tip='Edit this item' v-if='hasButton("edit")' @click.prevent='emit("edit")'><ion-icon name="settings"></ion-icon></a>
    <a data-tip='Delete this item' v-if='hasButton("delete")' @click.prevent='emit("delete")'><ion-icon name="close"></ion-icon></a>
    <a data-tip='Add a new item' v-if='hasButton("add")' @click.prevent='emit("add")'><ion-icon name="add"></ion-icon></a>
  </div>
</template>
<script>
import tippy from 'tippy.js'
import ReportEvents from '../lib/ReportEvents'
export default {
  props: {
    buttons: {type: Array, default: ()=>(['reorder', 'edit', 'delete', 'add'])}
  },
  methods: {
    notifyReorder (event) {
      ReportEvents.$emit('reorder', this.$parent)
    },
    emit (action) {
      this.$emit(action)
    },
    hasButton(action){
      return this.buttons.indexOf(action) !== -1
    }
  },
  mounted () {
    let buttons = document.querySelectorAll('a', this.$el)
    buttons.forEach((button)=> {
      if (!button.dataset.tip) {
        return
      }
      tippy(button, {
      content: button.dataset.tip,
      });
    })
  }
}
</script>
<style lang='scss' scoped>
  a {
    color: #fff;
    padding: 2px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border: 2px solid white;
    background-color: rgba(0,0,0,0.1);
    transition: 0.3s background-color;
    line-height:18px;
    & + a {
      margin-left: 12px;
    }
    &:hover {
      background-color: rgba(0,0,0,0.5);
    }
  }
  ion-icon {
    font-size: 22px;
    color: #fff;
  }
</style>